import { DashboardLayout } from '@/layouts/DashboardLayout'
import type { CurrentUser, Organization, Business } from '@/types'

interface InboxShowProps {
  embed_url: string
  current_user: CurrentUser | null
  current_organization: Organization | null
  current_business: Business | null
  org_slug: string
}

export default function InboxShow({
  embed_url,
  current_user,
  current_organization,
  current_business,
  org_slug,
}: InboxShowProps) {
  return (
    <DashboardLayout
      currentUser={current_user}
      currentOrganization={current_organization}
      currentBusiness={current_business}
      orgSlug={org_slug}
    >
      <div className="flex h-full flex-col gap-4">
        <div>
          <h1 className="text-2xl font-semibold">Inbox</h1>
          <p className="text-sm text-muted-foreground">
            Conversaciones de WhatsApp conectadas a Tippy.
          </p>
        </div>
        <div className="min-h-0 flex-1 overflow-hidden rounded-lg border border-border bg-background">
          <iframe
            src={embed_url}
            title="Kapso inbox"
            className="h-full w-full border-0"
            allow="clipboard-read; clipboard-write"
          />
        </div>
      </div>
    </DashboardLayout>
  )
}
